module.exports = __webpack_public_path__ + "static/img/UFOCatcherTop.33d5a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UFOCatcherTop.png
// module id = 9aXe
// module chunks = 2